import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'contextual-summary.project-summary.status-overview.title',
		defaultMessage: 'Status overview',
		description: 'Title of the breakdown by status overview section.',
	},
	description: {
		id: 'contextual-summary.project-summary.status-overview.description',
		defaultMessage: 'Get a snapshot of the status of your issues. <link>View all issues</link>',
		description: 'Description of the breakdown by status overview section.',
	},
	emptyDescription: {
		id: 'contextual-summary.project-summary.status-overview.empty-description',
		defaultMessage:
			'The status overview for this project will display here after you <link>create some issues</link>',
		description: 'Description of the breakdown by status overview section when empty.',
	},
	chartLabel: {
		id: 'contextual-summary.project-summary.status-overview.chart-label',
		defaultMessage: 'Total issues',
		description: 'Donut chart label for the status overview section.',
	},
});
